import React from 'react';

import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import {usePolicies} from 'app/policies/api';
import {CompactPolicyListItem} from 'app/policies/components/PoliciesDashboard/CompactPolicyListItem';
import {useRemoveTeamItem} from 'app/teams/api';
import {
  type ListItemProps,
  TeamListItem,
} from 'app/teams/components/TeamDetailPage/components/TeamListItem';
import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {gt} from 'app/utils/i18n';
import {POLICY_RTK_TAGS} from 'app/utils/rtk-tags';

import {AddNewTeamPolicyButton} from './AddNewTeamPolicyButton';

import type {DetailPolicySerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  onFetch: () => unknown;
};

type PolicyListItemProps = ListItemProps<DetailPolicySerializedType> & {
  team: TeamSerializedType;
};

export const TeamPoliciesSubPage = ({team}: Props) => {
  const [removeTeamItem] = useRemoveTeamItem();
  const remove = (
    team: TeamSerializedType,
    policy: DetailPolicySerializedType
  ) => removeTeamItem({teamURL: team.url, item: policy}).unwrap();
  const refetchList = () => {
    // @ts-expect-error we inject tags on the API after it's created so TS doesn't know any tag type
    actions.invalidateTags([{type: POLICY_RTK_TAGS.TAG, id: 'list'}]);
  };
  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="col-auto ml-auto">
            <AddNewTeamPolicyButton team={team} />
          </div>
        </TeamPageFilterBarStructure>
      ) : null}

      <GenericPaginatedListRTK
        ItemComponent={PolicyListItem}
        useQuery={usePolicies}
        noItemsMessage={(perms, NoResultsMessage) => (
          <NoResultsMessage head={gt('No policies for this team')}>
            <AddNewTeamPolicyButton
              buttonClass="btn btn-outline-primary"
              placement="top"
              team={team}
            />
          </NoResultsMessage>
        )}
        paramsBuilder={() => ({
          team_id: team.id,
          ordering: 'name',
        })}
        customProps={() => {
          return {
            remove,
            team,
            refetchList,
          };
        }}
      />
    </div>
  );
};

const PolicyListItem = ({
  object,
  team,
  remove,
  refetchList,
}: PolicyListItemProps) => (
  <TeamListItem
    object={object}
    team={team}
    remove={remove}
    contentType={'policy'}
    ListItem={CompactPolicyListItem}
    refetchList={refetchList}
  />
);
